import React, { memo, useCallback, useContext, useRef } from "react";
import { ImpressionContext, IntersectionContext } from ".";
import { generateEntityImpressionSnapshot } from "./ImpressionManager";

const IntersectionManager = memo(({ children }) => {
	const { activeEntities, isEntityActive, createEntityTimelineRecord } =
		useContext(ImpressionContext);

	const activateEntity = useCallback(
		({ id } = {}) => {
			if (!id) return;
			activeEntities.current.add(id);
			createEntityTimelineRecord(
				generateEntityImpressionSnapshot({
					id,
				})
			);
		},
		[activeEntities, createEntityTimelineRecord]
	);

	const deactivateEntity = useCallback(
		({ id } = {}) => {
			if (!id || !isEntityActive({ id })) return;
			activeEntities.current.delete(id);
		},
		[activeEntities, isEntityActive]
	);

	const handleIntersection = useCallback(
		(entities) => {
			entities.forEach((entity) => {
				// Ensure the observed entity has a configured data-intersectionuid
				const entityId = entity?.target?.dataset?.intersectionuid;
				if (!entityId) return;
				const isEntityActive = entity?.isIntersecting;
				isEntityActive
					? activateEntity({ id: entityId })
					: deactivateEntity({ id: entityId });
			});
		},
		[activateEntity, deactivateEntity]
	);

	const observer = useRef(
		new IntersectionObserver(handleIntersection, { threshold: 0.5 })
	);

	return (
		<IntersectionContext.Provider value={{ observer, isEntityActive }}>
			{children}
		</IntersectionContext.Provider>
	);
});

export default IntersectionManager;
